import s from './preloader.module.scss'
import {FC} from "react";
export const Preloader: FC = () => <div className={`${s.spinner} ${s.spinner__root}`}><i></i></div>
export const SmallPreloader: FC = () => <div className={`${s.spinner} ${s.spinner__button}`}><i></i></div>